import {SchemeLink} from '../../../applink/SchemeLink';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {theme} from '../../../theme';
import {BuyTicketBannerListProps} from './BuyTicketBannerListProps.interface';

export function BuyTicketBannerList({
  bannerList,
  className,
  ...props
}: BuyTicketBannerListProps) {
  if (!bannerList || !bannerList.length) {
    return null;
  }
  return (
    <div
      {...props}
      className={twMerge('bg-theme-bg-base px-15pxr pt-24pxr', className)}
    >
      {bannerList.map((banner, idx) => (
        <div
          className="cursor-pointer"
          style={{
            backgroundColor: banner.bgColor
              ? banner.bgColor
              : theme.colors['static-etc-bg-da'],
          }}
          key={banner.uid}
          onClickCapture={e => LOG_CLICK_EVENT('배너_클릭', e)}
          {...putTiaraObjectProps({
            click: {
              layer1: '이용권배너',
              ordnum: String(idx + 1),
            },
          })}
        >
          <SchemeLink
            shouldOpenNewWindow={banner.shouldOpenNewWindow}
            scheme={banner.scheme}
          >
            <div>
              <img
                src={banner.imageUrl}
                alt={banner.title || t('contenthome_accessibility_banner')}
                className={twMerge(
                  'm-auto mt-10pxr h-70pxr w-360pxr under-mobile:h-auto under-mobile:w-full',
                  idx === 0 && 'mt-0'
                )}
              />
            </div>
          </SchemeLink>
        </div>
      ))}
    </div>
  );
}
